export const RESET_SSR_HYDRATION = 'DOMAIN_DATA/RESET_SSR_HYDRATION';
export const SET_FETCH_MORE_RESULT = 'DOMAIN_DATA/SET_FETCH_MORE_RESULT';
export const SET_DOMAIN_DATA = 'DOMAIN_DATA/SET_DOMAIN_DATA';
export const FETCH_MORE = 'DOMAIN_DATA/FETCH_MORE';
export const INIT = 'DOMAIN_DATA/INIT';
export const RESET = 'DOMAIN_DATA/RESET';

